import {get} from 'components/api';
import {collaborator, profCollaborator} from '../../../constants/url';

async function getAssistantAdded(
  additional: string,
  token: string,
  useSpac: boolean,
) {
  let url = `${collaborator}?additional=${additional}`;
  if (useSpac) {
    url = `${profCollaborator}?additional=${additional}`;
  }
  return get(url, token);
}

export default getAssistantAdded;
